import { NoteComponent } from './note.component';

export const NOTE_DECLARATIONS: any[] = [NoteComponent];